import React, { useState, useContext, useEffect } from "react";
import Select from "react-select";
import { FilterContext } from "../FilterContextProvider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Button from "../Components/Button";
import Input from "../Components/Input";
import ReportsLayout from "./ReportsLayout";
import useEvents from "../hooks/useEvents";
import { exportToCSV } from "../Utility/Csv";
import { Link } from "react-router-dom";
import useApi from "../Api/Api";

const Payroll = (props) => {
  const { filterData } = useContext(FilterContext);
  const [artist, setArtist] = useState({});
  const api = useApi();

  const {
    events,
    pagy,
    setCurrentPage,
    eventDates,
    eventDateOptions,
    handleEventDateSelect,
    renderCustomEventDateSelector,
    sortFilter,
    setSortFilter,
    resetPagination,
    setSearchFilter,
  } = useEvents("show", "", false, true, props.isTotalPayroll);

  const sortOptions = [
    {
      label: "Date",
      value: "date",
    },
    ...(props.isTotalPayroll ? [{ label: "Artist", value: "artist" }] : []),
    {
      label: "City",
      value: "city",
    },
    {
      label: "State",
      value: "state",
    },
    {
      label: "Venue",
      value: "name",
    },
    {
      label: "Recently added",
      value: "created_at",
    },
  ];

  useEffect(() => {
    if (!props.isTotalPayroll && filterData.artist_id) {
      api.get(`/artists/${filterData.artist_id}`).then((r) => {
        setArtist(r.data);
      });
    }
  }, [api, filterData, props.isTotalPayroll]);

  const handleSortSelect = (option) => {
    if (option.value !== sortFilter) {
      setSortFilter(option.value);
      resetPagination();
      setCurrentPage(1);
    }
  };

  const [searchTimeout, setSearchTimeout] = useState();

  const handleSearchChange = (e) => {
    setSearchTimeout(e.target.value);
  };

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setSearchFilter(searchTimeout);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [searchTimeout, setSearchFilter]);

  const handlePageChange = (e) => {
    setCurrentPage(e.target.value);
  };

  const getArtistData = (event) => props.isTotalPayroll ? event.artist : artist;

  events.forEach((each) => {
    const artistData = getArtistData(each);
    if (each.vendor === "Artist") {
      each.payroll = artistData?.manager_payment;
    } else if (each.vendor === "Venue") {
      each.payroll = artistData?.venue_vended_manager_payment;
    } else {
      each.payroll = 0;
    }
  });

  const vendorPayroll = events.map((event) => {
    const artistData = getArtistData(event);
    return {
      Event_Date: event.formattedDate,
      ...(props.isTotalPayroll && { Artist: event.artist?.name }),
      City: event.city,
      County: event.county,
      State: event.state,
      Gross_Sales: event.gross_sales,
      Less_Tax: event.gross_sales - event.tax_net,
      Vendor: event.vendor,
      Show_Payment: event.payroll,
      Commission:
        event.vendor === "Artist" ? (event.gross_sales - event.tax_net) * artistData?.manager_commission_percentage : 0,
    };
  });

  const renderSelectArtistMessage = () => {
    return <div className="m-8 py-12 pl-4">Please select an artist from the filter in order to see events</div>;
  };

  const renderEventsTable = () => {
    return (
      <div>
        <div>
          <div className="max-w-max">
            <Link to="/reports">
              <div className="-mt-6 mb-6 font-medium text-black text-sm">
                <FontAwesomeIcon icon={faArrowLeft}></FontAwesomeIcon> Back to reports
              </div>
            </Link>
          </div>
          <div className="text-xl mt-7 pb-8 font-medium">{props.isTotalPayroll ? "Total Payroll" : "Payroll"}</div>
          <div className="-mt-5 mb-4 text-sm">
            <div className="flex">
              <div className="absolute mt-6 ml-2">
                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
              </div>
              <div className="w-1/4 text-xs">
                <Input
                  onChange={handleSearchChange}
                  value={searchTimeout}
                  placeholder="Search for events"
                  label="SEARCH"
                  bigPaddingLeft
                />
              </div>
              <div className="flex flex-col w-1/4 ml-2">
                <span className="text-xs">SORT BY</span>
                <Select
                  id="sort_filter"
                  className="text-xs font-light"
                  placeholder="Select sort by..."
                  options={sortOptions}
                  onChange={handleSortSelect}
                  value={sortOptions?.filter((each) => each.value === sortFilter)}
                />
              </div>
              <div className="flex flex-col text-sm w-1/4 ml-2">
                <span className="text-xs">SELECT DATE RANGE</span>
                <Select
                  id="date"
                  className="text-xs font-light w-full"
                  placeholder="Select date range"
                  options={eventDateOptions}
                  onChange={handleEventDateSelect}
                  value={eventDateOptions?.filter((each) => each.value === eventDates.dateButton)}
                />
              </div>
            </div>
            <div className="my-4 w-1/2">{eventDates.dateButton === "custom" && renderCustomEventDateSelector()}</div>
          </div>
        </div>
        {events.length > 0 ? (
          <div>
            <form>
              <table>
                <thead className="text-xs font-light">
                  <tr className="text-left border-b-2 h-11 w-full">
                    <td className="w-1/10">DATE</td>
                    {props.isTotalPayroll && <td className="w-1/5">ARTIST</td>}
                    <td className={props.isTotalPayroll ? "w-1/10" : "w-1/5"}>CITY</td>
                    <td className={props.isTotalPayroll ? "w-1/10" : "w-1/5"}>COUNTY</td>
                    <td className="w-thin">STATE</td>
                    <td className="w-1/10 text-right">GROSS SALES</td>
                    <td className="w-1/10 text-right">LESS TAX</td>
                    <td className="w-1/10 pl-4">VENDOR</td>
                    <td className="w-1/10 text-right">SHOW PAYMENT</td>
                    <td className="w-1/10 text-right">VENDOR COMMISSION</td>
                  </tr>
                </thead>
                <tbody>
                  {events.map((eventToRender, i) => {
                    return (
                      <tr key={eventToRender.id} className="border-b text-sm h-11">
                        <td id={`date_${i}`}>{eventToRender.formattedDate}</td>
                        {props.isTotalPayroll && <td id={`artist_${i}`}>{eventToRender?.artist?.name}</td>}
                        <td id={`city_${i}`}>{eventToRender?.city}</td>
                        <td id={`county_${i}`}>{eventToRender?.county}</td>
                        <td id={`state_${i}`}>{eventToRender?.state}</td>
                        <td id={`gross_sales_${i}`} className="text-right">
                          {eventToRender.gross_sales
                            ? eventToRender.gross_sales?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                            : 0?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })}
                        </td>
                        <td id={`less_tax_${i}`} className="text-right">
                          {eventToRender.gross_sales
                            ? (eventToRender.gross_sales - eventToRender.tax_net)?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                            : 0?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })}
                        </td>
                        <td id={`vendor_${i}`} className="pl-4">
                          {eventToRender?.vendor}
                        </td>
                        <td id={`show_payment_${i}`} className="text-right">
                          {eventToRender?.vendor === "Artist"
                            ? getArtistData(eventToRender)?.manager_payment?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                            : eventToRender?.vendor === "Venue"
                            ? getArtistData(eventToRender)?.venue_vended_manager_payment?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                            : 0?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })}
                        </td>
                        <td id={`vendor_commission_${i}`} className="text-right">
                          {eventToRender?.vendor === "Artist" && eventToRender.gross_sales
                            ? (
                                (eventToRender.gross_sales - eventToRender.tax_net) *
                                getArtistData(eventToRender)?.manager_commission_percentage
                              )?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })
                            : 0?.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              })}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </form>
          </div>
        ) : sortFilter ? (
          <div className="mx-12 py-16">No events match the provided filters</div>
        ) : (
          <div className="mx-12 py-16">{props.isTotalPayroll ? "No events found" : "No events have been added for this artist yet"}</div>
        )}
      </div>
    );
  };

  return (
    <ReportsLayout>
      <div>
        <div className="mt-8 mx-8 py-10 px-12 bg-white text-black rounded-lg border">
          {events.length > 0 && (
            <div className="flex justify-end text-sm">
              <Button
                className="button"
                text="Export"
                onClick={() => exportToCSV(vendorPayroll, props.isTotalPayroll ? "total_payroll_report" : `${filterData.artist_name}_vendor_payroll_report`)}
              ></Button>
            </div>
          )}
          {(filterData.artist_id || props.isTotalPayroll) ? renderEventsTable() : renderSelectArtistMessage()}
        </div>
        {events.length > 0 && (
          <footer className="text-sm mt-4 mx-8 pb-4 flex justify-between">
            <div className="ml-1 mr-8">
              Showing <span className="font-bold">{pagy.from} </span>to
              <span className="font-bold"> {pagy.to} </span>of
              <span className="font-bold"> {pagy.count} </span>results
            </div>
            <div className="mr-8">
              Page {pagy.page} of {pagy.last}
            </div>
            <div className="flex -mt-2">
              <span>
                <Button
                  className={pagy.page === 1 ? "button-white-disabled button-sm" : "button button-white button-sm"}
                  onClick={resetPagination}
                  text="First"
                  disabled={pagy.page === 1}
                ></Button>
              </span>
              <span className="mx-1">
                <Button
                  value={pagy.prev}
                  className={!pagy.prev ? "button-white-disabled button-sm" : "button button-white button-sm"}
                  onClick={handlePageChange}
                  text="Prev"
                  disabled={!pagy.prev}
                ></Button>
              </span>
              <span>
                <Button
                  value={pagy.next}
                  className={!pagy.next ? "button-white-disabled button-sm" : "button button-white button-sm"}
                  onClick={handlePageChange}
                  text="Next"
                  disabled={!pagy.next}
                ></Button>
              </span>
              <span className="ml-1">
                <Button
                  value={pagy.last}
                  className={
                    pagy.page === pagy.last ? "button-white-disabled button-sm" : "button button-white button-sm"
                  }
                  onClick={handlePageChange}
                  text="Last"
                  disabled={pagy.page === pagy.last}
                ></Button>
              </span>
            </div>
          </footer>
        )}
      </div>
    </ReportsLayout>
  );
};

export default Payroll;
